import React, { useState } from 'react';
import { apiPut, showToast } from '../../utils/apiUtils';
import { API_URLS } from '../../config/api';
import './InteractiveSceneInfo.css';

const InteractiveSceneInfo = ({
  novelId,
  sceneId,
  scene,
  setScene,
  refreshScene,
  isProduction = false,
  sceneType = 'interactive'
}) => {
  const [editingInfo, setEditingInfo] = useState(false);
  const [infoFormData, setInfoFormData] = useState({});

  const getToken = () => {
    return localStorage.getItem('token');
  };

  const handleEditInfo = () => {
    setEditingInfo(true);
    setInfoFormData({
      name: scene?.name || '',
      tag: scene?.tag || '',
      interactive: scene?.interactive !== undefined ? scene.interactive : true
    });
  };

  const handleSaveInfo = async () => {
    if (!infoFormData.name?.trim()) {
      showToast('Ошибка', 'Название сцены обязательно', 'error');
      return;
    }

    try {
      const token = getToken();
      const getInfoUrl = () => {
        if (sceneType === 'open_world') return isProduction ? API_URLS.PRODUCTION_OPEN_WORLD_SCENE(novelId, sceneId) : API_URLS.BUILDING_OPEN_WORLD_SCENE(novelId, sceneId);
        return isProduction ? API_URLS.PRODUCTION_INTERACTIVE_SCENE(novelId, sceneId) : API_URLS.BUILDING_INTERACTIVE_SCENE(novelId, sceneId);
      };
      const response = await apiPut(
        getInfoUrl(),
        {
          name: infoFormData.name.trim(),
          tag: infoFormData.tag?.trim() || '',
          help: scene?.help || '',
          description: scene?.description || '',
          interactive: infoFormData.interactive
        },
        {
          'X-Auth-Token': token,
          'Content-Type': 'application/json'
        }
      );

      if (response.status === 200) {
        const keyMap = { interactive: 'interactive_scenes', open_world: 'open_world_interactive_scenes' };
        const key = keyMap[sceneType] || 'interactive_scenes';
        const updatedScene = response.data[key]?.find(
          scene => scene.id === sceneId
        );

        if (updatedScene) {
          setScene(updatedScene);
        } else {
          console.warn('Updated scene not found in response');
        }

        setEditingInfo(false);
        showToast('Успех', 'Информация о сцене успешно обновлена!', 'success');
        if (refreshScene) refreshScene();
      }
    } catch (error) {
      console.error('Error updating scene info:', error);
      showToast('Ошибка', 'Ошибка при обновлении информации о сцене', 'error');
    }
  };

  const handleCancelEdit = () => {
    setEditingInfo(false);
    setInfoFormData({});
  };

  if (!scene) {
    return <div>Загрузка...</div>;
  }

  return (
    <div className="isi-wrap">
      <div className="isi-header">
        <h3 className="isi-title">Информация о сцене</h3>
        {!editingInfo && (
          <div className="isi-actions">
            <button
              className="isi-btn-edit"
              onClick={handleEditInfo}
            >
              Редактировать информацию
            </button>
          </div>
        )}
      </div>

      {editingInfo ? (
        <div className="isi-edit-form">
          <div className="isi-form-group">
            <label className="isi-label">Название сцены:</label>
            <input
              type="text"
              className="isi-input"
              value={infoFormData.name || ''}
              onChange={(e) => setInfoFormData({...infoFormData, name: e.target.value})}
              placeholder="Название сцены"
            />
          </div>
          <div className="isi-form-group">
            <label className="isi-label">Теги:</label>
            <input
              type="text"
              className="isi-input"
              value={infoFormData.tag || ''}
              onChange={(e) => setInfoFormData({...infoFormData, tag: e.target.value})}
              placeholder="Теги"
            />
            <small className="help-text">Слова через пробел</small>
          </div>
          {sceneType !== 'open_world' && (
            <div className="isi-form-group">
              <div className="isi-checkbox-group">
                <label className="isi-checkbox-label">
                  <input
                    type="checkbox"
                    className="isi-checkbox"
                    checked={infoFormData.interactive !== undefined ? infoFormData.interactive : true}
                    onChange={(e) => setInfoFormData({...infoFormData, interactive: e.target.checked})}
                  />
                  Разрешить сообщения пользователя
                </label>
                <small className="help-text">Когда включено, пользователи могут писать сообщения для взаимодействия с персонажами. Когда выключено, пользователи могут только выбирать из статических окончаний.</small>
              </div>
            </div>
          )}
          <div className="isi-actions">
            <button
              className="isi-btn-primary"
              onClick={handleSaveInfo}
            >
              Сохранить информацию
            </button>
            <button
              className="isi-btn-cancel"
              onClick={handleCancelEdit}
            >
              Отменить
            </button>
          </div>
        </div>
      ) : (
        <div className="isi-display">
          <div className="isi-item">
            <span className="isi-item-key">Название сцены</span>
            <span className="isi-item-val">{scene.name}</span>
          </div>
          <div className="isi-item">
            <span className="isi-item-key">Теги</span>
            <span className="isi-item-val">{scene.tag || 'Not set'}</span>
          </div>
          {sceneType !== 'open_world' && (
            <div className="isi-item">
              <span className="isi-item-key">Разрешить сообщения пользователя</span>
              <span className="isi-item-val">{scene.interactive !== undefined ? (scene.interactive ? 'Да' : 'Нет') : 'Да'}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InteractiveSceneInfo;
